import React from 'react';
import PageContainer from "../../../hoc/PageContainer";

const ServiceProjects = () => (
    <div>
        <PageContainer page="ServiceProjects">
            <h1 className="AboutUsTitle">SERVICE PROJECTS</h1>
            <div className="AboutUsText">
                <b>OUR CAUSES</b>
                <br/>
                <br/>
                Rotary is dedicated to six areas of focus to build international relationships, improve lives, and create a better world to support our peace efforts and end polio forever.
                <br/>
                The six areas of focus consist of :
                <br/>
                <br/>
                <ol>
                    <li>Promoting pace</li>
                    <li>Fighting disease</li>
                    <li>Providing clean water, sanitation, and hygiene</li>
                    <li>Savings mothers and children</li>
                    <li>Supporting education</li>
                    <li>Growing local economies</li>
                </ol>
                Since 2009, Rotary Club of Central have put effort in adapting the Rotary’s six areas of focus into various programs to dedicate our resources in the betterment of our community. A wide range of themes have since been used covering youth development, elderly care, children’s volunteering, underprivileged community support, environmental protection and international humanitarian services to over 10 countries.
                <br/>
                <br/>
                <b>OUR PROGRAMS</b>
                <br/>
                <br/>
                Rotary’s programs are developing the next generation of leaders, providing funding to make the world a better place, and making peace a priority. And our programs are not just for clubs members, it’s for all interested individuals to learn how you can make a difference in your community through Rotary.
                <br/>
                <br/>
                Here are the signature Rotary programs:
                <br/>
                <br/>
                <ol>
                    <li>Rotary Peace Fellowships</li>
                    <li>Rotary Community Corps</li>
                    <li> Rotary Youth Leadership Awards (RYLA)</li>
                    <li> Rotary Youth Exchange</li>
                    <li> New Generation Services Exchange</li>
                    <li> Grants</li>
                    <li> Scholarships</li>
                </ol>
                Since inception, Rotary Club of Central have participated in Rotary Youth Leadership Awards ( RYLA), Grants, Scholarships, Rotaract, Rotary Adopt A School and District Mentorship Program. To suit our community needs, we’ve also pioneered Kideract in HK and a team of Elderact to strengthen our volunteer resources.
            </div>
        </PageContainer>
    </div>
);

export default ServiceProjects;
